"use strict";

exports.__esModule = true;
exports.TooltipLine = exports.TooltipContent = exports.TooltipConditionType = exports.TooltipConditionText = exports.StripeChartCommentGrid = exports.IconTooltipUsername = exports.IconTooltipId = exports.IconTooltipContentHeader = exports.IconTooltipContentDescription = exports.IconTooltipContent = exports.EventIconContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var IconTooltipContent = exports.IconTooltipContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconTooltipContent",
  componentId: "sc-1amczfo-0"
})(["display:grid;grid-template-areas:\"icon header\" \"icon description\" \"icon date\";"]);
var IconTooltipContentHeader = exports.IconTooltipContentHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconTooltipContentHeader",
  componentId: "sc-1amczfo-1"
})(["grid-area:header;display:flex;justify-content:space-between;padding-left:8px;"]);
var IconTooltipContentDescription = exports.IconTooltipContentDescription = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconTooltipContentDescription",
  componentId: "sc-1amczfo-2"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;grid-area:description;width:200px;font-size:", ";color:", ";padding-left:8px;"], (0, _Theme.val)("fontSizeXS"), (0, _Theme.val)("color"));
var IconTooltipId = exports.IconTooltipId = _styledComponents["default"].span.withConfig({
  displayName: "styles__IconTooltipId",
  componentId: "sc-1amczfo-3"
})(["grid-area:ticketId;text-align:right;margin-left:5px;margin-top:1px;color:", ";font-size:", ";"], (0, _Theme.val)("TooltipContentColor"), (0, _Theme.val)("fontSizeXXXS"));
var EventIconContainer = exports.EventIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__EventIconContainer",
  componentId: "sc-1amczfo-4"
})(["grid-area:icon;color:", ";"], (0, _Theme.val)("TooltipContentColor"));
var IconTooltipUsername = exports.IconTooltipUsername = _styledComponents["default"].strong.withConfig({
  displayName: "styles__IconTooltipUsername",
  componentId: "sc-1amczfo-5"
})(["max-width:160px;white-space:nowrap;overflow:hidden;color:", ";font-size:", ";"], (0, _Theme.val)("color"), (0, _Theme.val)("fontSizeXS"));
var TooltipLine = exports.TooltipLine = _styledComponents["default"].p.withConfig({
  displayName: "styles__TooltipLine",
  componentId: "sc-1amczfo-6"
})(["display:flex;justify-content:space-between;max-width:350px;height:45px;& > *{word-break:break-all;max-height:45px;max-width:47%;}"]);
var TooltipConditionText = exports.TooltipConditionText = _styledComponents["default"].span.withConfig({
  displayName: "styles__TooltipConditionText",
  componentId: "sc-1amczfo-7"
})(["display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;"]);
var TooltipConditionType = exports.TooltipConditionType = _styledComponents["default"].p.withConfig({
  displayName: "styles__TooltipConditionType",
  componentId: "sc-1amczfo-8"
})(["margin-bottom:5px;width:max-content;max-width:200px;grid-area:header;"]);
var StripeChartCommentGrid = exports.StripeChartCommentGrid = _styledComponents["default"].div.withConfig({
  displayName: "styles__StripeChartCommentGrid",
  componentId: "sc-1amczfo-9"
})(["display:inline-grid;grid-auto-flow:column;grid-template-areas:\"header\" \"main\";"]);
var TooltipContent = exports.TooltipContent = _styledComponents["default"].p.withConfig({
  displayName: "styles__TooltipContent",
  componentId: "sc-1amczfo-10"
})(["display:inline-grid;grid-template-rows:repeat(12,auto);grid-auto-flow:column;grid-area:main;"]);